import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectSystemState } from './system.selectors';
import { selectBlockState } from './block.selectors';

export const selectDeviceListComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.DeviceListComponent
);

export const selectSystemDeviceStatusBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectDeviceListComponent,
  (systemState, DeviceListComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = DeviceListComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.devices;
  }
);

export const selectSystemDeviceStatusStatusBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectDeviceListComponent,
  (systemState, DeviceListComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = DeviceListComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.state;
  }
);